import type { ZodSchema } from 'zod';
import { validateSchema } from './validateSchema';

export const validateServiceRequest = <S extends ZodSchema>(schema: S) => validateSchema(schema);
